"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
var Section_1 = require("./Section");
require("./Panel.scss");
var pencilIcon = { iconName: 'Edit' };
exports.Panel = function (props) {
    var editableProps = props.editable, title = props.title, allowEdition = props.allowEdition, editTitle = props.editTitle, editText = props.editText, onChangeEdit = props.onChangeEdit, children = props.children, footer = props.footer, header = props.header;
    var _a = react_1.useState(editableProps !== null && editableProps !== void 0 ? editableProps : false), editable = _a[0], setEditable = _a[1];
    react_1.useEffect(function () {
        setEditable(editableProps !== null && editableProps !== void 0 ? editableProps : false);
    }, [editableProps]);
    var onChange = function () {
        if (onChangeEdit) {
            onChangeEdit(!editable);
        }
        setEditable(!editable);
    };
    return (react_1.default.createElement("div", { className: "eta-panel" },
        react_1.default.createElement("div", { className: "header" },
            header ? react_1.default.createElement(react_1.default.Fragment, null, header) : (react_1.default.createElement("div", { className: "title" },
                react_1.default.createElement(Section_1.Section, { title: title, size: Section_1.SectionSize.h2 }))),
            react_1.default.createElement("div", { className: "space" }),
            allowEdition && (react_1.default.createElement("div", { className: "editable" },
                ' ',
                react_1.default.createElement(react_2.ActionButton, { iconProps: pencilIcon, title: editTitle, text: editText || '', onClick: onChange, disabled: editable })))),
        children,
        react_1.default.createElement("div", { className: "footer" }, editable && footer)));
};
//# sourceMappingURL=Panel.js.map